import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/ManageFees.css";
import API_URL from "../apiConfig";

function uniqueBy(arr, keyFn) {
  const seen = new Set();
  return arr.filter(item => {
    const key = keyFn(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

const YEAR_LABELS = ["1st Year GNM", "2nd Year GNM", "3rd Year GNM"];
function getYearLabel(course_year) {
  return YEAR_LABELS[(Number(course_year) || 1) - 1] || `Year ${course_year}`;
}

const ManageFees = ({ token, user, principalMode }) => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError("");
    // Always use API_URL for backend calls!
    fetch(`${API_URL}/api/students`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) throw new Error("Failed to load students.");
        return res.json();
      })
      .then(data => {
        const unique = uniqueBy(Array.isArray(data) ? data : [], s => s.email || s.id || s.roll_no);
        setStudents(unique);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to load students.");
        setStudents([]);
        setLoading(false);
      });
  }, [token]);

  const filteredStudents = students.filter(s => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return (
      (s.name && s.name.toLowerCase().includes(term)) ||
      (s.email && s.email.toLowerCase().includes(term)) ||
      (s.roll_no && String(s.roll_no).toLowerCase().includes(term)) ||
      (s.course_year && String(s.course_year).toLowerCase().includes(term)) ||
      (s.batch_id && String(s.batch_id).toLowerCase().includes(term)) ||
      (s.session_year && String(s.session_year).toLowerCase().includes(term))
    );
  });

  return (
    <div className="manage-fees-container">
      <h2 className="manage-fees-title">Manage Fees</h2>
      <div className="manage-fees-controls">
        <input
          type="text"
          className="student-search-input"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          placeholder="Search by name, email, roll no, batch, class, session"
        />
      </div>
      <div className="student-list-table-wrapper">
        <table className="student-list-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Batch</th>
              <th>Class</th>
              <th>Session</th>
              <th>Roll No</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7}>Loading students...</td>
              </tr>
            ) : filteredStudents.length === 0 ? (
              <tr>
                <td colSpan={7}>No students found.</td>
              </tr>
            ) : (
              filteredStudents.map(student => (
                <tr key={student.id || student.email || student.roll_no}>
                  <td>{student.name || student.student_name || "Student"}</td>
                  <td>{student.email}</td>
                  <td style={{textAlign:"center"}}>{student.batch_id}</td>
                  <td style={{textAlign:"center"}}>
                    {getYearLabel(student.course_year)}
                  </td>
                  <td style={{textAlign:"center"}}>{student.session_year}</td>
                  <td style={{textAlign:"center"}}>{student.roll_no}</td>
                  <td>
                    <button
                      className="student-btn"
                      onClick={() => {
                        if (principalMode || (user && user.role === "principal")) {
                          navigate(`/principal/manage-fees/${student.id}`);
                        } else {
                          navigate(`/admin/manage-fees/${student.id}`);
                        }
                      }}
                    >
                      Manage Fees
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
    </div>
  );
};

export default ManageFees;